import { useState } from "react";

// The API key row on the Settings pages for the coverage layers (MeshMapper and FreqMapper): a masked box, Replace and Clear
// (Clear asks first), or a paste box while adding or replacing. The key is sent once and never shown again; the page only ever
// learns whether one is set.
const MASK = "••••••••••••••••••••";

export function ApiKeyField({
  labelId, keySet, busy, pastePlaceholder, description, clearQuestion, onSave, onClear, onEmpty,
}: {
  labelId: string;
  keySet: boolean;
  busy: boolean;
  pastePlaceholder: string;
  description: string;
  clearQuestion: string;
  onSave: (key: string) => Promise<void>;
  onClear: () => Promise<void>;
  /** Save was pressed with nothing pasted. */
  onEmpty: () => void;
}) {
  const [editing, setEditing] = useState(false);
  const [keyText, setKeyText] = useState("");
  const [confirmClear, setConfirmClear] = useState(false);

  async function save() {
    const key = keyText.trim();
    if (!key) {
      onEmpty();
      return;
    }
    await onSave(key);
    setKeyText("");
    setEditing(false);
  }

  async function clear() {
    setConfirmClear(false);
    await onClear();
  }

  return (
    <div className="settings-field mm-settings-block">
      <span id={labelId}>API key</span>
      {!editing && (
        <div className="mm-settings-keyrow">
          <input type="password" value={keySet ? MASK : ""} placeholder="No key set" readOnly disabled aria-labelledby={labelId} autoComplete="off" />
          {keySet ? (
            <>
              <button type="button" className="settings-save-btn" disabled={busy} onClick={() => setEditing(true)}>
                Replace
              </button>
              {!confirmClear ? (
                <button type="button" className="mm-settings-secondary" disabled={busy} onClick={() => setConfirmClear(true)}>
                  Clear
                </button>
              ) : (
                <span className="mm-settings-confirm">
                  {clearQuestion}
                  <button type="button" className="settings-save-btn" disabled={busy} onClick={clear}>
                    Yes, clear
                  </button>
                  <button type="button" className="mm-settings-secondary" onClick={() => setConfirmClear(false)}>
                    Keep
                  </button>
                </span>
              )}
            </>
          ) : (
            <button type="button" className="settings-save-btn" disabled={busy} onClick={() => setEditing(true)}>
              Add key
            </button>
          )}
        </div>
      )}
      {editing && (
        <div className="mm-settings-keyrow">
          <input
            type="password"
            value={keyText}
            onChange={(e) => setKeyText(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") save(); }}
            placeholder={pastePlaceholder}
            aria-labelledby={labelId}
            autoComplete="off"
            spellCheck={false}
            autoFocus
          />
          <button type="button" className="settings-save-btn" disabled={busy || !keyText.trim()} onClick={save}>
            Save key
          </button>
          <button type="button" className="mm-settings-secondary" disabled={busy} onClick={() => { setEditing(false); setKeyText(""); }}>
            Cancel
          </button>
        </div>
      )}
      <span className="settings-field-desc">{description}</span>
    </div>
  );
}
